module.exports = __webpack_public_path__ + "static/media/services3.a6a2ac3a.png";